export const elementAttributes = {
    action: 'aat-action',
    ignoreCache: 'aat-ignoreCache',
    key: 'aat-key',
    meta: 'aat-meta',
    track: 'aat',
};



//////////////////
// WEBPACK FOOTER
// ./~/@celine/passive-tracking/dist/types/element-attributes.js
// module id = ./node_modules/@celine/passive-tracking/dist/types/element-attributes.js
// module chunks = 0